var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(
    (['/landingpage', '/iraq', '/ksa'].indexOf(_vm.$route.path) < 0 &&
      [
        '/mob-about-us/' +
        _vm.$route.params.lang +
        '/' +
        _vm.$route.params.cinemaType ].indexOf(_vm.$route.path) < 0 &&
      [
        '/mob-tnc/' + _vm.$route.params.lang + '/' + _vm.$route.params.cinemaType ].indexOf(_vm.$route.path) < 0 &&
      [
        '/mob-ksa-tnc/' +
        _vm.$route.params.lang +
        '/' +
        _vm.$route.params.cinemaType ].indexOf(_vm.$route.path) < 0 &&
      [
        '/theatre-rules-mob/' +
        _vm.$route.params.lang +
        '/' +
        _vm.$route.params.cinemaType ].indexOf(_vm.$route.path) < 0 &&
      _vm.siteURL != '__empirecinemas.com__' &&
      _vm.siteURL != 'localhost:8082') ||
    (_vm.siteURL == 'localhost:8082' && _vm.languageVal)
  )?_c('Header'):_vm._e(),_vm._v(" "),_c('main',{staticClass:"site-main"},[_c('router-view')],1),_vm._v(" "),(_vm.$route.path != '/seats')?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74d84aba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1087
// module chunks = 4